import ExtensibleError from './ExtensibleError';

export default class ServiceHttpResponseError extends ExtensibleError {
  constructor(message, response, additionalInfo = null) {
    super(message, additionalInfo, 'ServiceHttpResponseError');

    this.response = response;
  }

  toString() {
    return `${this.message} - ${this.response.status}: ${this.response.statusText}\n\t`;
  }
}
